module.exports = __webpack_public_path__ + "img/logo.0cc0320b.png";